registerComponent("pages/videos", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * ⚠️ O embrulho `document.addEventListener('DOMContentLoaded', …)` de 2020
 * SAIU, e é ele que estava quebrando o submenu de temas desde a Fase 2. Em 2020
 * o `Component.init()` corria no `preloaded.before`, com os dois `<script defer>`
 * já executados e o `DOMContentLoaded` ainda por vir — o listener era registrado
 * a tempo e disparava. Agora o `registerComponent` inicializa DURANTE o despacho
 * do `DOMContentLoaded`, e um listener acrescentado no meio do despacho não é
 * chamado: o corpo nunca rodava, e a página ficava sem o abre/fecha, sem erro
 * nenhum no console.
 *
 * O corpo em si é o de 2020, vanilla. Os `getElementById` ficam presos ao
 * `document` como estavam — os três ids são únicos na página; só o `.bg-beige`,
 * que era um `document.querySelector`, passou ao `component`, porque ele é um
 * seletor de classe e `sections/history-content` também tem um `.bg-beige`.
 */

const showSubMenu = document.getElementById('showSubMenu');
const btnClose = document.getElementById('btnClose');
const subMenu = document.getElementById('subMenu');
const bgBeige = component.querySelector('.bg-beige');

showSubMenu.addEventListener('click', function () {
    const isActive = subMenu.classList.contains('active');
    subMenu.classList.toggle('active', !isActive);
    showSubMenu.classList.toggle('active', !isActive);

    if (isActive) {
        bgBeige.style.backgroundColor = '';
        btnClose.style.display = 'none';
    } else {
        bgBeige.style.backgroundColor = '#F3F0EA';
        btnClose.style.display = 'block';
    }
});

btnClose.addEventListener('click', function () {
    subMenu.classList.remove('active');
    showSubMenu.classList.remove('active');
    bgBeige.style.backgroundColor = '';
    btnClose.style.display = 'none';
});

});
